import { baseApi } from "../../helpers/baseApi/origin.baseApi";
import type { IUserStats, IUserUsage } from "./types";


const extendedApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserUsageRequest: build.query<
      IUserUsage,
      {
        id?: number;
      }
    >({
      query: ({ id }) => ({
        url: `/user-usages/${id}`,
        method: "get",
      }),
      transformResponse: (response: IUserUsage, meta, arg) => response,
      transformErrorResponse: (response, meta, arg) => response,
    }),
    getUserStatsRequest: build.query<
      IUserStats,
      {
        id?: number;
      }
    >({
      query: ({ id }) => ({
        url: `/user-stats/${id}`,
        method: "get",
      }),
      transformResponse: (response: IUserStats, meta, arg) => response,
      transformErrorResponse: (response, meta, arg) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserUsageRequestQuery,
  useGetUserStatsRequestQuery,
  endpoints,
} = extendedApi;
